(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function tnHeaderToTitleCase(text) {
    if (!text || !text.trim()) return text;

    return text.replace(/[A-Za-zÀ-ÿ0-9][A-Za-zÀ-ÿ0-9'’&.-]*/g, function(word) {
      if (word.length <= 2 && word === word.toUpperCase()) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function tnNormalizeMobileDrawerTextCase(root) {
    var scope = root || document;
    var selectors = [
      '.menu-drawer__menu-item',
      '.menu-drawer summary',
      '.menu-drawer__close-button',
      '.menu-drawer__account'
    ];

    var elements = scope.querySelectorAll(selectors.join(','));

    elements.forEach(function(element) {
      if (!element || element.dataset.tnCaseFixed === 'true') return;

      var walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(node) {
            if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
            if (node.parentElement && node.parentElement.closest('svg')) return NodeFilter.FILTER_REJECT;
            if (node.parentElement && node.parentElement.classList.contains('visually-hidden')) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      var nodes = [];
      var currentNode;

      while ((currentNode = walker.nextNode())) {
        nodes.push(currentNode);
      }

      nodes.forEach(function(node) {
        var original = node.nodeValue;
        var trimmed = original.trim();

        if (trimmed.length > 1 && trimmed === trimmed.toUpperCase()) {
          node.nodeValue = original.replace(trimmed, tnHeaderToTitleCase(trimmed));
        }
      });

      element.dataset.tnCaseFixed = 'true';
    });
  }

  function tnRunDrawerFixes() {
    tnNormalizeMobileDrawerTextCase(document);
  }

  document.addEventListener('DOMContentLoaded', tnRunDrawerFixes);
  document.addEventListener('shopify:section:load', tnRunDrawerFixes);
  document.addEventListener('click', function(event) {
    if (event.target && event.target.closest && event.target.closest('header-drawer, .menu-drawer-container')) {
      window.setTimeout(tnRunDrawerFixes, 50);
      window.setTimeout(tnRunDrawerFixes, 250);
    }
  });

  window.setTimeout(tnRunDrawerFixes, 50);
  window.setTimeout(tnRunDrawerFixes, 350);
  window.setTimeout(tnRunDrawerFixes, 1000);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
      tnRunDrawerFixes();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');

      if (scrollTop > 8) {
        this.header.classList.add('scrolled-past-header', 'animate');
      } else {
        this.header.classList.remove('scrolled-past-header', 'animate');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
